/* Auto-start found a technician on the visit still busy — see "a technician on
 * the visit is still busy" in store.js and js/rules/auto-start.js.
 *
 * Asked rather than decided (Kevin, 2026-10-20): stop the square they are on
 * and start this one, give it to somebody else, or leave it in Due now. One
 * line at a time, so each answer is about one person; the next one follows.
 * Out of the way while a sheet it opened (the assign sheet) or one of the
 * other questions is up, and back when that is done.
 */
import * as Vue from 'vue';
import { store } from '../store.js';

var STATE_LABEL = { started: 'Started', held: 'Waiting to be checked in', done: 'Done', open: 'Not started' };

export const AutoStartAsk = {
  name: 'AutoStartAsk',
  setup: function () {
    var lines = Vue.computed(function () { return store.autoStartAskView.value; });
    var q = Vue.computed(function () {
      var ui = store.ui;
      if (ui.assign || ui.orderAsk || ui.bookClash) return null;
      return lines.value ? lines.value[0] : null;
    });
    var more = Vue.computed(function () { return lines.value ? lines.value.length - 1 : 0; });

    // Whole sentences rather than text stitched around {{ }}: the compiler eats
    // the whitespace either side of an interpolation and the seams show.
    var headline = Vue.computed(function () {
      if (!q.value) return '';
      return q.value.staff.name + ' is still busy';
    });
    var body = Vue.computed(function () {
      var x = q.value;
      if (!x) return '';
      var out = x.appt.clientName + '’s ' + x.svc.name + ' with ' + x.staff.name + ' at ' +
        store.formatClock(x.svc.startsAt) + ' was due to start with the rest of the visit.';
      var t = x.busyTurn;
      if (t) {
        out += ' ' + x.staff.name + ' is on ' + (t.clientName ? t.clientName + '’s ' : 'a ') +
          t.serviceName + ' since ' + store.formatClock(t.startedAt) +
          (t.scheduledEndAt ? ', booked to finish at ' + store.formatClock(t.scheduledEndAt) : '') + '.';
      }
      return out;
    });
    var requestNote = Vue.computed(function () {
      var x = q.value;
      if (!x || !x.requested) return '';
      return x.appt.clientName + ' asked for ' + x.staff.name +
        '. Giving it to somebody else drops the request.';
    });

    function label(choice) {
      var x = q.value;
      if (!x) return '';
      if (choice === 'wait') return 'Leave it in Due now';
      if (choice === 'stop') {
        var t = x.busyTurn;
        return 'Stop ' + x.staff.name + '’s ' + (t ? t.serviceName : 'service') + ' and start this';
      }
      return x.requested ? 'Give it to somebody else' : 'Give it to the next technician';
    }
    function lineState(v) {
      if (q.value && v.id === q.value.svcId) return 'Waiting on ' + q.value.staff.name;
      return STATE_LABEL[v.state] || '';
    }
    function answer(choice) { if (q.value) store.answerAutoStartAsk(q.value.svcId, choice); }

    return {
      q: q, more: more, headline: headline, body: body, requestNote: requestNote,
      label: label, lineState: lineState, answer: answer,
      formatClock: store.formatClock,
      // Dismissed is the same as waiting, for every line on it.
      close: store.closeAutoStartAsk
    };
  },
  template: [
    '<div v-if="q" class="modal-scrim" @click.self="close">',
    '  <div class="sheet" role="alertdialog" aria-modal="true">',
    '    <div class="sheet__head sheet__head--warn">',
    '      <span class="sheet__letter sheet__letter--warn">{{ q.requested ? "\\u2605" : "!" }}</span>',
    '      <div>',
    '        <h3>{{ headline }}</h3>',
    '        <p>{{ body }}</p>',
    '      </div>',
    '    </div>',
    '',
    '    <div class="assign__section">',
    '      <h4 class="assign__label">{{ q.appt.clientName }}’s visit<client-note :client-id="q.appt.clientId" /></h4>',
    '      <ul class="clash-list">',
    '        <li v-for="v in q.visit" :key="v.id" :class="{ \'is-free\': v.state === \'started\' }">',
    '          <span class="clash-list__who">{{ formatClock(v.startsAt) }} {{ v.name }}<template v-if="v.tech"> &middot; {{ v.tech }}</template></span>',
    '          <span class="clash-list__why">{{ lineState(v) }}</span>',
    '        </li>',
    '      </ul>',
    '      <p v-if="requestNote" class="warn-body">{{ requestNote }}</p>',
    '    </div>',
    '',
    '    <div class="sheet__actions">',
    '      <button v-for="(c, i) in q.choices" :key="c" type="button"',
    '        :class="i === 0 ? \'btn btn--primary btn--lg\' : \'btn btn--ghost\'"',
    '        @click="answer(c)">{{ label(c) }}</button>',
    '    </div>',
    '    <p v-if="more" class="sheet__hint">{{ more === 1 ? "One more service on the visit is waiting on a busy technician." : more + " more services are waiting on busy technicians." }}</p>',
    '  </div>',
    '</div>'
  ].join('\n')
};
